import { authClient } from "@/shared/lib/axios";
import {
	type GetGyulDebtResponse,
	GetGyulDebtResponseSchema,
	type GetMeResponse,
	GetMeResponseSchema,
	type UpdateMeRequest,
	UpdateMeResponseSchema,
} from "./user.types";

const USER_ENPOINT = "/user";

export const userApi = {
	// 내 정보 조회
	getMe: async (): Promise<GetMeResponse> => {
		const { data } = await authClient.get(`${USER_ENPOINT}/me`);
		return GetMeResponseSchema.parse(data);
	},

	// 내 정보 수정
	updateMe: async (request: UpdateMeRequest) => {
		const { data } = await authClient.patch(`${USER_ENPOINT}/me`, request);
		return UpdateMeResponseSchema.parse(data);
	},

	// 귤 부채 조회
	getGyulDebt: async (): Promise<GetGyulDebtResponse> => {
		const { data } = await authClient.get(`${USER_ENPOINT}/gyul-debts`);
		return GetGyulDebtResponseSchema.parse(data);
	},
};
